import { useCities } from 'providers/cities';
import { ReactComponent as EmailIcon } from 'assets/icons/Email.svg';
import { ReactComponent as PhoneIcon } from 'assets/icons/Phone.svg';
import { ReactComponent as HelpIcon } from 'assets/icons/Help.svg';
import { ReactComponent as PrivacyIcon } from 'assets/icons/privacy.svg';
import { useId } from 'react-id-generator';
import { MouseEventHandler } from 'react';
import { useTranslation } from 'react-i18next';

declare const window: Window &
  typeof globalThis & {
    Cookiebot: any;
  };

export const useFooterLinks = () => {
  const { selectedCity } = useCities();
  const ids = useId(4);
  const { t } = useTranslation();

  const cookiebotShowEvent: MouseEventHandler = () => {
    const cookiebot = window.Cookiebot;
    if (cookiebot !== false) {
      cookiebot.show();
    }
  };

  const footerLinks = [
    {
      icon: PrivacyIcon,
      title: t('footer.privacy'),
      onClickEvent: cookiebotShowEvent,
      id: ids[0],
    },
    {
      icon: EmailIcon,
      title: selectedCity?.mail,
      href: `mailto:${selectedCity?.mail}`,
      id: ids[1],
    },
    {
      icon: PhoneIcon,
      title: selectedCity?.phone,
      href: `tel:${selectedCity?.phone}`,
      id: ids[2],
    },
    {
      icon: HelpIcon,
      title: t('footer.help'),
      href: `mailto:pagalba@tvarkaumiesta.lt`,
      id: ids[3],
    },
  ];

  return footerLinks;
};
